import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getStoreDetails: EvokeAction<AppState, AppActions> = async store => {
  try {
    const details = await api.get("stores/details");
    
    await store.update(state => {
      state.storeDetails = details;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const storeActions = {
    getStoreDetails
};